import { Classroom } from '@/api/classroom'

const state = () => ({
    rooms: [],
    roomPagination: {},
    isLoadingRoom: false,
    isSuccessRoom: true,
    messageRoom: null,
})

const getters = {
    rooms: state => state.rooms,
    roomPagination: state => state.roomPagination,
    isLoadingRoom: state => state.isLoadingRoom,
    isSuccessRoom: state => state.isSuccessRoom,
    messageRoom: state => state.messageRoom,

}

const actions = {
    async fetchAllRooms({ commit }, query = null) {
        let page = 1
        let perPage = 50
        if(query !== null) {
            page = query.page
            perPage = query.perPage
        }
        commit('setIsLoadingRoom', true)
        await Classroom.getAllRooms(perPage, page)
        .then(response => {
            commit('setRooms', response.data.data)
            const pagination = {
                total: response.data.pages.total,
                perPage: response.data.pages.per_page,
                page: response.data.pages.current_page,
                from: response.data.pages.from
            }
            commit('setRoomPagination', pagination)
            commit('setIsLoadingRoom', false)
        })
        .catch(error => {
            console.log(error)
            commit('setIsLoadingRoom', false)
        })
    },
    async fetchOneRoom({ commit }, id) {
        commit('setIsLoadingRoom', true)
        await Classroom.getOneRoom(id)
        .then(response => {
            commit('setRoom', response.data.data)
            commit('setIsLoadingRoom', false)
        })
        .catch(error => {
            console.log(error)
            commit('setIsLoadingRoom', false)
        })
    },
    async createRoom({ commit }, payload) {
        await Classroom.addRoom(payload)
        .then(res => {
            if (res.data.success) {
                commit('setIsSuccessRoom', true)
                commit('setMessageRoom', 'Berhasil Menambahkan Room')
            } else {
                commit('setIsSuccessRoom', false)
                commit('setMessageRoom', 'Terjadi Kesalahan')
            }
        })
        .catch(error => {
            commit('setIsSuccessRoom', false)
            commit('setMessageRoom', error.errors[0].message)
        })
    },
    async editRoom({commit}, data) {
        const id = data.id
        const payload = data.payload
        await Classroom.updateRoom(id, payload)
        .then(res => {
            if(res.data.success) {
                commit('setIsSuccessRoom', true)
                commit('setMessageRoom', 'Berhasil Mengubah Room')
            } else {
                commit('setIsSuccessRoom', false)
                commit('setMessageRoom', 'Berhasil Mengubah Room')
            }
        })
        .catch(err => {
            commit('setIsSuccessRoom', false)
            commit('setMessageRoom', err.erros[0].message)
        })
    },
    async removeRoom({ commit }, hot) {
        await Classroom.deleteRoom(hot)
        .then(res => {
            if (res.data.success) {
                commit('setIsSuccessRoom', true)
                commit('setMessageRoom', 'Berhasil Menghapus Room')
            } else {
                commit('setIsSuccessRoom', false)
                commit('setMessageRoom', 'Terjadi Kesalahan')
            }
        })
        .catch(error => {
            commit('setIsSuccessRoom', true)
            commit('setMessageRoom', error.errors[0].message)
        })
    }
}

const mutations = {
    setRooms: (state, rooms) => {
        state.rooms = rooms
    },

    setRoomPagination: (state, pagination) => {
        state.roomPagination = pagination
    },

    setIsLoadingRoom: (state, loading) => {
        state.isLoadingRoom = loading
    },

    setIsSuccessRoom: (state, status) => {
        state.isSuccessRoom = status
    },

    setMessageRoom: (state, message) => {
        state.messageRoom = message
    },

}

export default {
    state,
    getters,
    actions,
    mutations
}